define(
  'marqueeFirstElementInitializer',[
    'builderShowcaseObserver',
    'builderShowcaseHelper',
  ],
  (
    builderShowcaseObserver,
    showcaseHelper,
  ) => {
    'use strict';

    /**
    * @private
    * getCollection: gets the collection of the selected image.
    */
    function getCollection(state, subCollection) {
      const data = state.data.galleryCollections;
      const parameter = `${subCollection.toLowerCase()}Collection`;
      return data[parameter];
    }

    /**
    * @private
    * initializeFirstElement: activates the first filmstrip element. Particulary util
    * when the first element is a video and the video handlers need to be executed.
    */
    function initializeFirstElement(configuration) {
      if (!configuration.filmstripItems || configuration.filmstripItems.length === 0) {
        return;
      }

      const imageId = configuration.filmstripItems[0].querySelector('picture').dataset.imageId;
      const activeCategory = configuration.filmstripItems[0].querySelector('picture').dataset.imageCategory;
      const activeElement = showcaseHelper.getCollectionItem(imageId, activeCategory, getCollection);
      const autoInitMediaElements = ['Videos', 'Tours'];

      if (autoInitMediaElements.indexOf(activeElement.HolderCollectionName) === -1) {
        return;
      }

      const activeImage = {};
      activeImage.marqueeGallery = activeElement;
      builderShowcaseObserver.setData({ activeImage });
      builderShowcaseObserver.commit();
      builderShowcaseObserver.imageSelected(activeElement);
      configuration.filmstripItems[0].querySelector('PICTURE').setAttribute('data-active', true);
    }

    return {
      initializeFirstElement,
    };
  }
);

